import {DataFetcher} from '@aboutyou/data-fetcher';
import React, {FC} from 'react';
import {MerchantLegalInfoWrapperHandler} from './MerchantLegalInfoWrapperHandler';
import {useMerchantLegalInfo} from './useMerchantLegalInfo';

interface MerchantLegalInfoProps {
  productId: number;
  sizeId: number;
  onClose: VoidFunction;
}

export const MerchantLegalInfo: FC<MerchantLegalInfoProps> = props => {
  return (
    <DataFetcher
      request={useMerchantLegalInfo({
        productId: props.productId,
        sizeId: props.sizeId,
      })}
      Error={null}
      Loading={() => null}
      View={MerchantLegalInfoWrapperHandler}
      viewProps={props}
    />
  );
};
